import React, { createContext, ReactNode, useContext } from 'react';

interface RoleContextValue {
    userRole: string;
}

interface RoleProviderProps {
    children: ReactNode;
    userRole: string;
}

export const RoleContext = createContext<RoleContextValue | undefined>(undefined);

// Custom hook to use the context
export const useRoleContext = (): RoleContextValue => {
    const context = useContext(RoleContext);
    if (context === undefined) {
        throw new Error('useRoleContext must be used within a RoleContextProvider');
    }
    return context;
};

export const RoleContextProvider: React.FC<RoleProviderProps> = ({ children, userRole }) => {
    const value: RoleContextValue = {
        userRole
    };

    return <RoleContext.Provider value={value}>{children}</RoleContext.Provider>;
};